/* eslint-disable import/no-extraneous-dependencies */
import { Button, Drawer, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { t } from '$i18n'
import { setLastContactPermissionRejectionTime } from '$setup/notification'
import { isInTwa } from '$func/environmentInfo'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication/twaCommunication.types'

const StyledDrawer = styled(Drawer)({
  '.MuiDrawer-paper': {
    maxHeight: `100%`,
    height: `100%`,
    backgroundColor: 'white',
    overflow: 'hidden',
  },
})

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  margin-top: auto;
  gap: 12px;
`

const StyledButton = styled(Button)(({ theme }) => ({
  height: '48px',
  borderRadius: '8px',
  color: theme.palette.neutral000,
  backgroundColor: theme.palette.primary500,
}))

export function ContactDialog({ isOpen }: { isOpen: boolean }) {
  return (
    <StyledDrawer
      open={isOpen}
      anchor="bottom"
      onClose={() => {
        closeCurrentModal()
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '64px 16px',
          gap: '32px',
          alignItems: 'center',
        }}
      >
        <img
          src="assets/svg/contact-dialog.svg"
          width="240px"
          height="180px"
          alt=""
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          <Typography variant="h2">
            {t('permissionModal.contact.title')}
          </Typography>
          <Typography variant="paragraph1" textAlign="center">
            {t('permissionModal.contact.description')}
          </Typography>
        </div>
      </div>
      <ButtonContainer>
        <StyledButton
          variant="contained"
          fullWidth
          onClick={() => {
            if (isInTwa) sendEventToTwa(TWA_EVENTS.CHECK_CONTACT_PERMISSION)
            closeCurrentModal()
          }}
        >
          {t('permissionModal.contact.activate')}
        </StyledButton>
        <Button
          fullWidth
          onClick={() => {
            setLastContactPermissionRejectionTime()
            closeCurrentModal()
          }}
          variant="text"
          sx={{ color: 'neutral900' }}
        >
          {t('permissionModal.notYet')}
        </Button>
      </ButtonContainer>
    </StyledDrawer>
  )
}
